<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>

<div class="text-lg mb-5">Close Tasks</div>

<form [formGroup]="searchForm" class="search-form-card" (ngSubmit)="searchHandler()">
  <!-- Case Number -->
  <div class="search-grid">
   <app-case-number-search [label]="userType==='lawyer'?'Case Number':'Appeal Number'"
          (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
        </app-case-number-search>
  
  <!-- Task ID -->
  <div class="form-item">
    <mat-label>Task ID</mat-label>
    <mat-form-field appearance="outline" class="full-width">
      <input matInput formControlName="taskId"  />
      <mat-error *ngIf="searchForm.get('taskId')?.hasError('required')">Field value required</mat-error>
    </mat-form-field>
  </div>

  <!-- Task Type Name -->
 <div class="form-item">
  <mat-label>Task Type Name</mat-label>

  <!-- Loader shown when task types are loading -->
  <div *ngIf="isTaskLoading; else showDropdown" class="flex items-center justify-center h-12">
    <mat-progress-spinner
      diameter="30"
      mode="indeterminate"
      color="accent"
      strokeWidth="3"
    ></mat-progress-spinner>
  </div>

  <!-- Dropdown shown when not loading -->
  <ng-template #showDropdown>
    <mat-form-field appearance="outline" class="full-width">
      <mat-select formControlName="taskTypeName" (click)="onTaskTypeDropdownClick()">
        <mat-option *ngFor="let category of taskTypeName" [value]="category">
          {{ category.taskName }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="searchForm.get('taskTypeName')?.hasError('required')">
        Field value required
      </mat-error>
    </mat-form-field>
  </ng-template>
</div>


  <!-- Buttons -->
  <div class="form-actions">
    <button type="reset" mat-stroked-button color="primary" (click)="resetHandler()">Reset</button>
    <button type="submit" mat-flat-button color="primary">Search</button>
  </div>
  </div>
</form>

<!-- Task Table -->
<div class="flex pb-3">
  <div class="flex-grow bg-fieldset">
    <div class="flex px-4 border-slate-400 border-b items-center mb-4">
      <h2 class="text-lg">Tasks</h2>
    </div>
    <div class="px-4" >
      @if (!isLoading) {
        <cdk-virtual-scroll-viewport itemSize="24" class="h-60 border" >
          <div style="overflow-x: auto;">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

            <!-- Task ID -->
            <ng-container matColumnDef="tasksId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Task ID</th>
              <td mat-cell *matCellDef="let element">{{ element.tasksId }}</td>
            </ng-container>

            <!-- Task Name -->
            <ng-container matColumnDef="taskTypeName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Name</th>
              <td mat-cell *matCellDef="let element">{{ element.taskTypeName }}</td>
            </ng-container>

            <!-- Case ID -->
            <ng-container matColumnDef="caseId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{isSupremeCourtFlg?"Appeal ID":"Case ID"}}</th>
              <td mat-cell *matCellDef="let element">{{ element.caseId }}</td>
            </ng-container>

            <!-- Case Number -->
            <ng-container matColumnDef="caseCourtCaseNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{isSupremeCourtFlg ? "Appeal Number":"Case Number"}}</th>
              <td mat-cell *matCellDef="let element">{{ element.caseCourtCaseNumber }}</td>
            </ng-container>
            
            <!-- Due Date -->
            <ng-container matColumnDef="tasksDue">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
              <td mat-cell *matCellDef="let element">{{ element.tasksDue | date: 'dd-MMM-yyyy' }}</td>
                          </ng-container>

            <ng-container matColumnDef="comment">
              <th mat-header-cell *matHeaderCellDef><span class="text-red-600">*</span> Comment</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field appearance="outline" class="w-full pt-4">
                  <input
                    matInput
                    [(ngModel)]="element.comment"
                    [name]="'comment_' + element.tasksId"
                    placeholder="Enter comment"
                    [disabled]="!element.isEditing"
                  />
                </mat-form-field>
              </td>
            </ng-container>


            <!-- Actions -->
           <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="!element.isEditing; else editMode">
                  <!-- Edit as text button with icon -->
                  <button mat-button color="primary" (click)="element.isEditing = true">
                    <mat-icon class="mr-1">edit</mat-icon> Edit
                  </button>
                </ng-container>

                <ng-template #editMode>
                  <!-- Save as text button with icon -->
                  
                  <ng-container *ngIf="!isSaveLoading; else loadingButton">
              <button mat-button color="primary" (click)="onCloseTask(element)">
                <mat-icon class="mr-1">remove_circle</mat-icon> Close Task
              </button>
            </ng-container>

            <ng-template #loadingButton>
              <button mat-button disabled>
                <mat-progress-spinner
                  diameter="20"
                  mode="indeterminate"
                  color="primary"
                  strokeWidth="3">
                </mat-progress-spinner>
              </button>
            </ng-template>

                  <!-- Cancel as red button with icon -->
                  <button mat-button color="red" (click)="element.isEditing = false">
                    <mat-icon class="mr-1" style="color: red;">cancel</mat-icon> Cancel
                  </button>
                </ng-template>
              </td>
            </ng-container>


            <!-- Header & Row definitions -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          </div>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="flex justify-center items-center h-40">
          <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
        </div>
      }
    </div>
  </div>
</div>
